import { render, staticRenderFns } from "./TextComponent.vue?vue&type=template&id=7e76ac67&scoped=true&"
import script from "./TextComponent.vue?vue&type=script&lang=ts&"
export * from "./TextComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e76ac67",
  null
  
)

export default component.exports